
global.colorTheme = {
	mainDark: '#004d26',
	main: '#008241', //green
	mainLight: '#00FF7F',
	secondaryDark: '#6b4e2b',
	secondary: '#ffb966', //yellow
	secondaryLight: '#ffdea4',
	grey: '#808080',
	background: '#EBECEF', //light grey
	error: '#BF142A',
}

global.SetColorTheme = (colorTheme)=>{

	if(colorTheme === undefined) return;

	global.colorTheme = colorTheme;

	const sekerStyle = document.styleSheets[0];
	const styleRules = sekerStyle.cssRules;

	const secondary = global.colorTheme.secondaryLight;
	const secondaryWithAlpha = global.hexToRGB(secondary,0.5);

	for(let i=0; i<styleRules.length; i++){
		let rule = styleRules[i].selectorText;
		if(rule === "body"){
			sekerStyle.deleteRule(i);
			sekerStyle.insertRule(`body {
				margin: 0;
				padding: 0;
				font-family: simplerReg;
				direction: rtl;
				background-color: rgb(221, 222, 226);
			  }`,i);
		}

		if(rule === "a"){
			sekerStyle.deleteRule(i);
			sekerStyle.insertRule(`a {
				color: ${global.colorTheme.main};
				text-decoration: none;
				border: 0px;
				border-bottom: solid 2px currentColor;
			  }`,i);
		}

		if(rule === ".slider::-webkit-slider-thumb"){
			sekerStyle.deleteRule(i);
			sekerStyle.insertRule(`.slider::-webkit-slider-thumb {
				-webkit-appearance: none;
				appearance: none;
				width: 32px;
				height: 32px;
				background: ${global.colorTheme.main};
				border-radius: 100%;
				cursor: pointer;
			  }`,i);
		}

		if(rule === ".slider::-moz-range-thumb"){
			sekerStyle.deleteRule(i);
			sekerStyle.insertRule(`.slider::-moz-range-thumb {
				width: 32px;
				height: 32px;
				background: ${global.colorTheme.main};
				border-radius: 100%;
				cursor: pointer;
			  }`,i);
		}
		
		if(rule === ".ms_slider::-ms-thumb"){
			sekerStyle.deleteRule(i);
			sekerStyle.insertRule(`.ms_slider::-ms-thumb {
				width: 32px;
				height: 32px;
				background: ${global.colorTheme.main};
				border: 0px;
				border-radius: 100%;
			  }`,i);
		}
	}

	sekerStyle.insertRule(`input:focus, textarea:focus { 
		outline: none;
		border-width: 2px;
		background: ${global.colorTheme.secondaryLight};
		
	}`, Math.max(styleRules.length-1, 0));

	document.querySelector('meta[name="theme-color"]').setAttribute("content", global.colorTheme.main)

	// console.log("index change color. theme: " + JSON.stringify(colorTheme));
	const event = new CustomEvent('COLOR_THEME_UPDATED', {detail: colorTheme});
	window.dispatchEvent(event);
	

}

global.hexToRGB=(hex, alpha)=> {
	var r = parseInt(hex.slice(1, 3), 16),
		g = parseInt(hex.slice(3, 5), 16),
		b = parseInt(hex.slice(5, 7), 16);

	if (alpha) {
		return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
	} else {
		return "rgb(" + r + ", " + g + ", " + b + ")";
	}
}


// WEBPACK FOOTER //
// ./src/ColorTheme.js